import { AlertTriangle, CheckCircle2, Loader2, RotateCcw } from "lucide-react";
import { PHASES, STEPS } from "@/lib/enhanceApi";

/** First-time processing steps, or the "stopped" message with Try again. */
export default function ProgressCard({ item, onRetry, retrying }) {
  if (item.status === "error") {
    return (
      <section data-testid="enhance-error" className="flex flex-wrap items-center justify-between gap-3 rounded-3xl border border-rose-400/25 bg-rose-500/10 p-5">
        <span className="flex items-center gap-2 text-[14px] text-rose-100"><AlertTriangle className="h-4 w-4" /> {item.error || "Something went wrong."}</span>
        <button type="button" data-testid="enhance-retry" onClick={onRetry} disabled={retrying}
          className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-[13px] font-semibold text-black disabled:opacity-50">
          {retrying ? <Loader2 className="h-4 w-4 animate-spin" /> : <RotateCcw className="h-4 w-4" />} Try again
        </button>
      </section>
    );
  }
  const steps = STEPS.filter((s) => s !== "isolating" || item.isolate);
  const at = steps.indexOf(item.phase);
  return (
    <section data-testid="enhance-progress" className="rounded-3xl border border-white/[0.08] bg-[#0a0d1c]/80 p-6">
      <h2 className="flex items-center gap-2 font-display text-base font-semibold md:text-lg"><Loader2 className="h-4 w-4 animate-spin text-amber-300" /> {PHASES[item.phase] || "Working"}…</h2>
      <p className="mt-1 text-[13px] text-white/50">Usually under a minute for a 3-minute vocal{item.isolate ? ", plus about a minute to remove the music" : ""}. You can leave this page — it keeps going.</p>
      <ol className="mt-5 space-y-2.5">
        {steps.map((s, i) => (
          <li key={s} data-testid={`enhance-step-${s}`} className={`flex items-center gap-2.5 text-[13px] ${i <= at ? "text-white" : "text-white/35"}`}>
            {i < at ? <CheckCircle2 className="h-4 w-4 text-emerald-300" /> : i === at ? <Loader2 className="h-4 w-4 animate-spin text-amber-300" /> : <span className="h-4 w-4 rounded-full border border-white/20" />}
            {PHASES[s]}
          </li>
        ))}
      </ol>
    </section>
  );
}
